export const SIZES = {
  extraSmall: 'x-small',
  small: 'small',
  medium: 'medium',
  large: 'large',
  responsive: 'responsive',
  extraLarge: 'x-large',
}
